import { render, staticRenderFns } from "./IdDescricaoLabel.vue?vue&type=template&id=31091238&scoped=true"
import script from "./IdDescricaoLabel.vue?vue&type=script&lang=js"
export * from "./IdDescricaoLabel.vue?vue&type=script&lang=js"
import style0 from "./IdDescricaoLabel.vue?vue&type=style&index=0&id=31091238&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31091238",
  null
  
)

export default component.exports